import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const menuItems = [
    { label: 'Home', url: 'http://www.ahadees.com/', external: true },
    { label: 'Al Quran', url: 'http://www.ahadees.com/quran.html', external: true },
    { label: 'Ahadees', url: 'http://www.ahadees.com/ahadees.html', external: true },
    { label: 'Duain', url: 'http://www.ahadees.com/duain.html', external: true },
    { label: 'Durood Sharif', url: 'http://www.ahadees.com/durood.html', external: true },
    { label: 'Naat City', url: '/', highlight: true, external: false },
    { label: 'Islamic Books', url: 'http://www.islamicbookslibrary.com', external: true },
    { label: 'Gallery', url: 'http://ahadees.net/gallery', external: true },
    { label: 'Contact', url: 'http://www.ahadees.com/contact.html', external: true },
    { label: 'Privacy Policy', url: '/privacy-policy', external: false },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links-wrapper">
          {menuItems.map((item, index) => (
            <a
              key={index}
              href={item.url}
              target={item.external ? "_blank" : undefined}
              rel={item.external ? "noopener noreferrer" : undefined}
              className={`footer-link ${item.highlight ? 'active' : ''}`}
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;